// Segments (PRD 137: class, department and location tags on journal lines)
// ship dark. The api's Wave 1 is built, but segments belong to the
// `forecasting` module (PRD 137 §4.11, D1), which is not released, and tagging
// entries is not useful until Wave 3's reports can read the tags back — a tag
// nobody can report on is data entry with no payoff.
//
// While false: no Administration tile, no /business/settings/segments route,
// and the journal entry form and its lines grid draw no segment picker or
// column, and keep every label they had (the property column still says
// "Class"). Tests flip it with jest.mock of this module.
//
// Flipping it is a one-line PR, released together with the module. Kept as a
// constant rather than a runtime flag for the COMBINED_REPORTING_LIVE reason:
// a rollback is the same one-line PR.
export const SEGMENTS_RELEASED = false;
